import CASL from '@/utils/constants/casl'

export default {
  path: 'vendor-hc',
  children: [
    {
      path: '',
      name: 'vendor-hc.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.VENDOR_HC
      },
      component: () => import('./list/VendorHCListPage.vue')
    }
  ]
}
